import SitePageLayout from '../components/SitePageLayout';

export default function TermsOfServiceScreen() {
  return (
    <SitePageLayout title="Terms of Service" effectiveDate="March 24, 2026">
      <p>
        These Terms of Service ("Terms") govern your use of Wreckoning Ball (the "App"), a product of
        Xerratus, LLC ("Company," "we," "us," or "our"). By using the App, you agree to these
        Terms.
      </p>

      <section className="legal-section">
        <h2>1. Service Overview</h2>
        <p>
          Wreckoning Ball is an entertainment app that provides daily sign-based readings,
          personalized dooms, Ball responses, reactions, bookmarks, sharing tools, theme and
          profile settings, and related account features.
        </p>
      </section>

      <section className="legal-section">
        <h2>2. Eligibility</h2>
        <p>
          You must be legally permitted to use the App in your jurisdiction and old enough to
          consent to these Terms.
        </p>
      </section>

      <section className="legal-section">
        <h2>3. Accounts and Security</h2>
        <p>
          You are responsible for activity under your account and for maintaining the confidentiality
          of your credentials. You are also responsible for keeping your profile information accurate
          if you choose to provide it.
        </p>
      </section>

      <section className="legal-section">
        <h2>4. AI and Personalized Features</h2>
        <ul>
          <li>Certain features depend on AI processing and may require your separate consent in the App.</li>
          <li>Personalized features depend on the information you choose to provide and may produce variable results.</li>
          <li>You understand that AI-generated content may be inaccurate, incomplete, strange, or more confident than necessary.</li>
        </ul>
      </section>

      <section className="legal-section">
        <h2>5. Acceptable Use</h2>
        <p>
          You agree not to misuse the service, interfere with the App, violate laws, attempt to gain
          unauthorized access, scrape or reverse engineer the service except where prohibited by law,
          or use the App in a way that infringes the rights of others.
        </p>
      </section>

      <section className="legal-section">
        <h2>6. Sharing and User Content</h2>
        <ul>
          <li>You may share doom content or images using tools made available in the App.</li>
          <li>You are responsible for what you share and where you share it.</li>
          <li>We are not responsible for third-party platforms, their moderation decisions, or their terms.</li>
        </ul>
      </section>

      <section className="legal-section">
        <h2>7. Purchases and Subscriptions</h2>
        <p>
          Some features may be offered as paid purchases or subscriptions. Billing, renewals,
          cancellation, and refunds are handled by Apple App Store and Google Play under their
          terms, not ours.
        </p>
      </section>

      <section className="legal-section">
        <h2>8. Intellectual Property</h2>
        <p>
          The App, software, and branding are owned by Xerratus, LLC and its licensors and are
          protected by law.
        </p>
      </section>

      <section className="legal-section">
        <h2>9. Entertainment Disclaimer</h2>
        <p>
          Wreckoning Ball is provided for entertainment and informational purposes only. The App
          does not provide medical, legal, financial, mental health, or other professional advice.
        </p>
        <p>
          If you make a life decision because a sarcastic astrology app told you to, that decision
          remains yours.
        </p>
      </section>

      <section className="legal-section">
        <h2>10. No Warranty</h2>
        <p>
          The App is provided "as is" and "as available" without warranties of any kind, including
          warranties that it will be uninterrupted, error-free, or perfectly accurate.
        </p>
      </section>

      <section className="legal-section">
        <h2>11. Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by law, Wreckoning Ball is not liable for indirect,
          incidental, or consequential damages arising from use of the App.
        </p>
      </section>

      <section className="legal-section">
        <h2>12. Suspension and Termination</h2>
        <p>
          You may stop using the App at any time. We may suspend or terminate access for
          violations of these Terms.
        </p>
      </section>

      <section className="legal-section">
        <h2>13. Account Deletion</h2>
        <p>
          The App includes an account deletion flow. Deleting your account is intended to remove
          your account record and related app data, subject to technical limitations, required
          reauthentication, backup retention, and legal obligations.
        </p>
      </section>

      <section className="legal-section">
        <h2>14. Changes to Terms</h2>
        <p>
          We may update these Terms from time to time. Continued use after changes means you
          accept the updated Terms.
        </p>
      </section>

      <section className="legal-section">
        <h2>15. Contact</h2>
        <p>For legal/support questions: support@xerratus.com</p>
      </section>
    </SitePageLayout>
  );
}
